import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyForm: React.FC = () => {
  return (
    <main className='px-6 py-12'>
      <div className='mx-auto max-w-[800px]'>
        <h1 className='mb-6 border-b border-gray-300 pb-4 text-2xl font-bold'>
          DXPNプライバシーポリシー
        </h1>
        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>
            1. 個人情報及び特定個人情報等保護に関する基本的な方針
          </h2>
          <p className='mb-4'>
            株式会社NTT DXパートナー（以下「NTT
            DXパートナー」といいます。）は、個人情報及び特定個人情報等の保護に対する社会的要請を十分に認識し、個人情報及び特定個人情報等の適正な取り扱いを推進していくことが、重大な社会的責務であるものと考えております。
          </p>
          <p className='mb-4'>
            NTT
            DXパートナーは、このような責務を十分に果たしていくとともに、安心・安全なサービスを提供し、皆様に信頼される企業であり続けるため、「NTTグループ情報セキュリティポリシー」及び以下の基本的な方針に従い、全社を挙げて個人情報及び特定個人情報等の保護に努めてまいります。
          </p>
          <ol className='mb-4 list-decimal pl-6'>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等の保護に関連する法令等※1の規定に従って個人情報及び特定個人情報等の適正な取り扱いを行っていく等、コンプライアンス（法令遵守）の徹底に努めてまいります。
            </li>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等の利用目的を明確に定めるとともに、その利用目的の達成に必要な範囲内で適正に個人情報及び特定個人情報等を取り扱います。また、個人情報及び特定個人情報等を正確かつ最新の内容に保つよう努めます。
            </li>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等の適正な管理のため、個人情報保護管理者を置くとともに各組織に個人情報保護に関する責任者及び特定個人情報等保護に関する責任者並びに事務取扱担当者を配置する等の責任体制を整備します。
            </li>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等を取り扱う業務に従事する者に対して必要な教育研修等を実施するとともに適切な監督を行います。また、個人情報及び特定個人情報等の取り扱いを外部に委託する場合には、守秘義務契約の締結等により委託先においても適正に取り扱われるよう管理、監督します。
            </li>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等の安全性の確保のため、各種の基準・ガイドライン等を参照しつつ、必要な安全管理措置を講じます。
            </li>
            <li>
              NTT DXパートナーは、NTT
              DXパートナーにおける個人情報及び特定個人情報等の取り扱いに関するお客様からのご意見、ご相談等に対して適切に対応します。
            </li>
            <li>
              NTT
              DXパートナーは、個人情報及び特定個人情報等の保護の一層の推進のため、管理体制、安全管理措置その他必要な措置の継続的な改善に努めます。
            </li>
          </ol>
          <p className='mb-4'>
            なお、NTT
            DXパートナーは、個人情報のみならず、法人その他の団体のお客様に関する情報についても等しく厳格に保護していくことが重要であるものと認識しております。NTT
            DXパートナーは、これらの情報についても個人情報と同様に適正に取り扱ってまいります。
          </p>
          <h3 className='mb-2 text-lg font-semibold'>
            ※1 個人情報及び特定個人情報等の保護に関連する法令等の具体例
          </h3>
          <ol className='list-disc pl-6'>
            <li>
              個人情報の保護に関する法律（平成15年法律第57号。以下「個人情報保護法」といいます。）
            </li>
            <li>電気通信事業法（昭和59年法律第86号）</li>
            <li>
              電気通信事業における個人情報保護に関するガイドライン（平成16年総務省告示第695号）
            </li>
            <li>
              医療・介護関係事業者における個人情報の適切な取扱いのためのガイダンス（平成29年4月14日
              個人情報保護委員会 厚生労働省）
            </li>
            <li>
              個人情報の保護に関する法律についてのガイドライン（通則編、匿名加工情報編、第三者提供時の確認・記録義務編、外国にある第三者への提供編）（平成28年11月
              個人情報保護委員会）
            </li>
            <li>
              行政手続における特定の個人を識別するための番号の利用等に関する法律（平成25年法律第27号。以下「番号法」といいます。）
            </li>
            <li>
              特定個人情報の適正な取扱いに関するガイドライン（事業者編）（平成26年12月11日個人情報保護委員会）
              等
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>2. 個人情報の具体的な取り扱いに関する方針</h2>
          <h3 className='mb-2 text-lg font-semibold'>
            (1) NTT DXパートナーが取り扱う個人情報の取得方法
          </h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、口頭、書面、電磁的記録媒体、メール・Web画面等に入力された電磁的記録、録音、録画その他の方法をもってお客様の個人情報※2を適法かつ公正に取得します。(お客様から直接取得する以外に、当社がお客様以外から間接的に取得する場合を含みます。)
          </p>
          <p className='mb-4'>
            なお、お客様との電話応対時においては、ご注文・ご意見・ご要望・お問い合わせ内容等の正確な把握、今後のサービス向上のために、通話を録音させていただく場合があります。
          </p>
          <p className='mb-4'>
            ※2 個人情報 ：
            個人情報保護法第2条が規定する個人情報をいい、個人データ及び保有個人データを含みます。また、個人のお客様以外のお客様の場合には、そのお客様の代表者、役員、従業員等に関する個人情報のうち、サービス等の提供・販売等に際してNTT
            DXパートナーが取り扱うこととなるものを含みます。ただし、本プライバシーポリシーにおいて、特定個人情報等は含みません。以下においても同様とします。
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(2) 利用目的</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、前記(1)に記載した方法により取得した個人情報を取り扱うに当たり、次のとおり利用目的を定めます。
          </p>
          <ol className='mb-4 list-decimal pl-6'>
            <li>当社各種サービスの提供・検証・改善</li>
            <li>当社サービスに関連する新サービスの開発・実験・検証</li>
            <li>当社サービスに関連するマーケティング調査</li>
            <li>お客様からのお問い合わせへの対応・お客様のサポート</li>
            <li>当社または第三者のサービス等に関する通知・ご案内</li>
            <li>当社が他の事業者から委託された業務の実施に必要となる範囲での利用</li>
            <li>料金請求・課金・決済</li>
            <li>業務上の連絡、取引及び契約上の権利義務の履行その他の管理</li>
            <li>オンラインコミュニティ機能上での表示名</li>
            <li>匿名加工情報※3に加工したうえでの第三者への販売</li>
          </ol>
          <p className='mb-4'>
            ※3 匿名加工情報 ： 個人情報保護法第2条が規定する匿名加工情報をいいます。
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>
            (3) 他の事業者等に対する業務委託等を伴う個人情報の提供
          </h3>
          <p className='mb-4'>
            NTT
            DXパートナーが取り扱う個人情報は、個人情報保護法第23条第5項第1号の規定に基づき、前記(2)の業務について、NTT
            DXパートナーは個人情報の取り扱いの全部又は一部を委託する他の事業者に対して提供することがあります。この場合、DXパートナーは、個人情報を適正に取り扱うと認めた事業者等を選定し、委託契約において、安全管理措置、秘密保持、再委託の条件その他の個人情報の適正な取り扱いに必要な事項を定め、適切に監督します。
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(4) 第三者への個人情報等の提供</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、以下のいずれかに該当する場合を除き、いかなる第三者にも提供または開示いたしません。
          </p>
          <ol className='mb-4 list-decimal pl-6'>
            <li>ご本人の同意がある場合</li>
            <li>前記(3)に掲げる業務委託等をする場合</li>
            <li>
              匿名加工情報、及び統計的なデータなどご本人を識別することができない状態で開示・提供する場合
            </li>
            <li>法令に基づき開示・提供を求められた場合</li>
            <li>
              人の生命、身体または財産の保護のために必要な場合であって、ご本人の同意を得ることが困難である場合
            </li>
            <li>
              国または地方公共団体等が公的な事務を実施するうえで、協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(5) 共同利用</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、お預かりしている個人情報等を、特定の者との間で共同利用することはいたしません。
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>
            (6) 安全管理措置に関する基本的な考え方(セキュリティ・ポリシー)
          </h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、個人情報を取り扱うに当たり、個人情報を安全に管理するため、以下のような措置を適切に実施するよう努めます。
          </p>
          <ol className='mb-4 list-none pl-6'>
            <li>
              <strong>1. 技術的な保護措置</strong>
              <p className='mb-4 mt-2'>
                個人情報へのアクセス管理、持出し手段の制限、外部からの不正アクセスの防止等に適切な措置を講じることにより、個人情報への不正なアクセスや個人情報の漏えい、滅失、毀損の防止に努めます。
              </p>
            </li>
            <li>
              <strong>2. 組織的な保護措置</strong>
              <ol className='mb-4 mt-2 list-disc pl-6'>
                <li className='mb-2'>ご本人の同意がある場合</li>
                <li>
                  個人情報を安全に管理するため、社内規程、マニュアル等を定め、個人情報を取り扱う業務に従事する者に遵守させるとともに、遵守状況についても定期的に適切に管理、監督します。
                </li>
                <li>
                  個人情報を取り扱う業務に従事する者に対して定期的に適切な教育研修を実施することにより、個人情報の重要性について十分に認識し個人情報を適正に取り扱うよう、従業者一人ひとりの意識の向上に努めます。
                </li>
                <li>
                  個人情報の取り扱いを外部に委託する場合には、守秘義務契約の締結等により委託先においても適正に取り扱われるよう監督します。
                </li>
              </ol>
            </li>
            <li>
              <strong>3. 物理的な保護措置</strong>
              <p className='mb-4 mt-2'>
                個人情報を取り扱う建物やフロアの入退室管理、盗難等の防止、システムや文書の持出し・保管時における施錠などの諸対策を講じます。
              </p>
            </li>
            <li>
              <strong>4. 外的環境の把握</strong>
              <p className='mb-4 mt-2'>
                個人情報を取り扱う建物やフロアの入退室管理、盗難等の防止、システムや文書の持出し・保管時における施錠などの諸対策を講じます。
              </p>
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(7) 開示・訂正等の手続</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、個人情報等の利用目的の通知又は個人情報、個人情報第三者提供に係る記録の開示（以下「開示等」といいます。）若しくは個人情報等の訂正、追加若しくは削除又は利用停止（以下「訂正等」といいます。）のお申出（以下「開示・訂正等のお申出」といいます。）について、以下のとおり手続を定めます。
          </p>
          <h4 className='text-md mb-2 font-semibold'>1. 開示・訂正等のお申出先</h4>
          <p className='mb-4'>
            03-6803-4400
            <br />
            （午前9時～午後5時30分／土曜・日曜・休日･年末年始を除く）
          </p>
          <h4 className='text-md mb-2 font-semibold'>2. 開示・訂正等の手続</h4>
          <ol className='mb-4 list-none pl-6'>
            <li>
              <strong>ア．開示等の手続</strong>
              <ol className='mb-2 list-disc pl-6'>
                <li className='mb-2'>
                  NTT
                  DXパートナーは、開示等のお申出があったときは、電磁的記録の提供による方法、書面の交付による方法その他当社の定める方法のうちお客様が請求した方法により回答します。ただし、お客様が請求した方法により開示を行うことが困難であると当社が判断したときは、その旨及びその理由をお伝えし、書面の交付による開示を行います。いずれの場合においても、お客様からの開示等のお申出は、NTT
                  DXパートナーがあらかじめ定めた様式に従った書面を提出することにより行っていただくものとします。
                </li>
                <li className='mb-2'>
                  NTT
                  DXパートナーは、開示等のお申出があった場合においても、個人情報保護法の規定に基づき、その一部又は全部について開示等をしないことがあります。この場合においては、NTT
                  DXパートナーは、開示等をしない旨及びその理由をお知らせします。なお、代理人に対しては、特定個人情報等を開示することにより人の生命、身体、財産その他の権利利益を害するおそれがある場合等は、対象となる個人情報の全部又は一部を開示しないことがあります。
                </li>
                <li className='mb-2'>
                  開示等をご希望の方は前記[1]記載のお申出先にご連絡ください。手続の詳細についてご案内します。
                </li>
              </ol>
            </li>
            <li>
              <strong>イ．訂正等の手続</strong>
              <ol className='mb-2 list-disc pl-6'>
                <li className='mb-2'>
                  NTT
                  DXパートナーは、訂正等のお申出があったときは、そのお申出内容について調査を行います。この場合において、訂正等のお申出はNTT
                  DXパートナーがあらかじめ定めた様式に従った書面を提出することにより行っていただくものとします。
                </li>
                <li className='mb-2'>
                  NTT
                  DXパートナーは、調査の結果、個人情報等の内容が事実でないとき、又はお客様の権利若しくは正当な利益が害されるおそれがあるとき、その他当該個人情報の取り扱いが適正でないと認めるときは訂正等を行います。
                </li>
                <li className='mb-2'>
                  訂正等をご希望の方は前記1記載のお申出先にご連絡ください。手続の詳細についてご案内します。
                </li>
              </ol>
            </li>
          </ol>
          <h4 className='text-md mb-2 font-semibold'>3. 本人確認等</h4>
          <p className='mb-4'>
            開示・訂正等のお申出に当たっては、対象となる個人情報に係る本人又はその代理人であることを確認できる書面が必要となります。必要となる書面の詳細については前記1記載のお申出先にお尋ねください。
          </p>
          <h4 className='text-md mb-2 font-semibold'>4. 開示等のお申出に係る手数料の額等</h4>
          <ol className='mb-4 list-disc pl-6'>
            <li>
              <strong>手数料：</strong> お申出ごとに基本料金400円(税抜)
              及び、開示希望情報の項目、量等に応じた手数料が加算されます。
            </li>
            <li>
              <strong>送料：</strong> 簡易書留による郵送に係る実費
            </li>
            <li>
              <strong>請求方法：</strong> ご請求の都度、請求書を送付します。
            </li>
            <li>その他手数料の額等の詳細については、前記1記載のお申出先にお尋ねください。</li>
          </ol>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>
            (8) 個人情報の取り扱いに関するご意見等の受付窓口
          </h3>
          <p className='mb-4'>
            NTT
            DXパートナーの個人情報等の取り扱いに関するご相談、ご要望等については、以下のお申出先で承ります。
          </p>
          <p className='mb-4'>
            <strong>03-6803-4400</strong>
            <br />
            （午前9時～午後5時30分 ／ 土曜・日曜・休日･年末年始を除く）
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(9) 取得した個人情報の加工</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、取得した個人情報をもとに、仮名加工情報、匿名加工情報を作成することがあります。その場合は、個人情報保護法の規定に従い適切な措置を講じます。
          </p>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>(10) 個人関連情報の取り扱い</h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、個人関連情報（生存する個人に関する情報であって、個人情報、仮名加工情報及び匿名加工情報のいずれにも該当しないものをいい、具体的には、ウェブサイトの閲覧履歴や位置情報等を指します。）を以下のとおり取り扱います。
          </p>
          <ol className='mb-4 list-none pl-6'>
            <li className='mb-2'>
              <strong>1. NTT DXパートナーが個人関連情報を提供する場合</strong>
              <p className='mb-6 mt-2'>
                NTT
                DXパートナーは、提供先の第三者が個人関連情報を個人データとして取得することが想定されるときは、個人情報保護法第27条第1項各号による場合以外は、お客様本人からあらかじめ同意を得ていること（当該第三者が外国にある場合、同意を得るにあたって、当該外国の名称、個人情報の保護に関する制度、当該第三者が講ずる個人情報の保護のための措置その他の当該本人に参考となるべき情報が当該本人に提供されていることを含みます。）を確認することなく、当該第三者へ個人関連情報を提供いたしません。
              </p>
            </li>
            <li className='mb-2'>
              <strong>2. NTT DXパートナーが個人関連情報を個人データとして取得する場合</strong>
              <p className='mt-2'>
                NTT
                DXパートナーは、個人関連情報を個人データとして取得する場合には、お客様本人からあらかじめ同意を得るものとします。ただし、当該個人データを提供しようとする者においてお客様本人から同意を得ている場合には、あらかじめ同意を得ることに代えることができるものとします。
              </p>
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h3 className='mb-4 text-lg font-semibold'>
            (11) 外国にある第三者への個人情報又は個人関連情報の提供に係る対応
          </h3>
          <p className='mb-4'>
            NTT
            DXパートナーは、外国（個人の権利利益を保護する上で日本と同等の水準にあると認められる個人情報の保護に関する制度を有している国は除きます。）にある第三者に個人情報又は個人関連情報を提供する場合には、以下の対応を行います。
          </p>
          <section className='mb-6'>
            <h4 className='text-md mb-3 font-semibold'>1. 外国にある第三者への個人情報の提供</h4>
            <ol className='mb-4 list-none pl-6'>
              <li className='mb-2'>
                <strong>ア．同意取得による方法</strong>
                <p className='mt-2'>
                  NTT
                  DXパートナーは、以下の事項についてあらかじめお客様へお知らせし、同意を得たうえで、外国にある第三者へ個人情報を提供することがあります。
                </p>
                <ul className='mt-2 list-disc pl-6'>
                  <li>提供先となる外国の名称</li>
                  <li>当該外国における個人情報の保護に関する制度</li>
                  <li>提供先の第三者が個人情報の保護のために講ずる措置</li>
                </ul>
              </li>
              <li className='mb-2'>
                <strong>イ．外国にある第三者の体制整備による方法</strong>
                <p className='mt-2'>
                  上記ア、のほか、NTT
                  DXパートナーは、外国にある第三者による相当措置の継続的な実施を確保するために必要な措置を講じたうえで、外国にある第三者へ個人情報を提供することがあります。
                </p>
              </li>
            </ol>
          </section>
          <section className='mb-6'>
            <h4 className='text-md mb-3 font-semibold'>
              2. 外国にある第三者への個人関連情報の提供
            </h4>
            <ol className='mb-4 list-none pl-6'>
              <li className='mb-2'>
                <strong>ア．同意取得による方法</strong>
                <p className='mt-2'>
                  NTT DXパートナーは、上述(10)
                  1の定めに従ったうえで、外国にある第三者へ個人関連情報を提供することがあります。
                </p>
              </li>
              <li className='mb-2'>
                <strong>イ．外国にある第三者の体制整備による方法</strong>
                <p className='mt-2'>
                  上記ア、のほか、NTT DXパートナーは、上述(10)
                  1に定める同意（ただし、括弧内の情報提供がされていることの確認は除きます。）を得ていることを確認し、外国にある第三者による相当措置の継続的な実施を確保するために必要な措置を講じたうえで、外国にある第三者へ個人関連情報を提供することがあります。
                </p>
              </li>
            </ol>
          </section>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>
            3. 特定個人情報等の具体的な取り扱いに関する方針
          </h2>
          <section className='mb-6'>
            <h3 className='mb-3 text-lg font-semibold'>(1) 利用目的</h3>
            <p className='mb-4'>
              NTT DXパートナーで保有する特定個人情報等※4の利用目的は次の範囲のとおりです。
            </p>
            <ol className='mb-4 list-decimal pl-6'>
              <li className='mb-2'>報酬、料金、契約金、及び賞金の支払調書作成に係る事務</li>
              <li className='mb-2'>不動産の使用料等の支払調書作成に係る事務</li>
              <li className='mb-2'>不動産等の譲受けの対価の支払調書作成に係る事務</li>
              <li className='mb-2'>
                不動産等の売買又は貸付けのあっせん手数料の支払調書作成に係る事務
              </li>
            </ol>
            <p className='mb-4'>
              なお、特定個人情報等は、利用目的の範囲で適正な方法により提供を求めます。また、直接書面にて記載された特定個人情報等をお預かりする場合は、個人情報保護法第18条第4項各号に該当する場合を除き、その都度、利用目的を明示させていただきます。ただし、番号法第29条第3項で読み替える個人情報保護法第16条第3項第1号又は第2号にあたる場合はこの限りではありません。
            </p>
            <p className='mb-4'>
              ※4 特定個人情報等 ：
              個人番号及び個人番号をその内容に含む個人情報をいいます。以下においても同様とします。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-3 text-lg font-semibold'>(2) 第三者への特定個人情報等の提供</h3>
            <p className='mb-4'>
              NTT
              DXパートナーは、特定個人情報等を第三者に提供しません。ただし、番号法第19条各号に定める場合には、事前に本人の同意を得ることなく、必要な特定個人情報等を関係する第三者に提供すること、又は、関係する第三者から必要な特定個人情報等の提供を受けることがあります。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-3 text-lg font-semibold'>
              (3) 他の事業者等に対する業務委託に伴う特定個人情報等の提供
            </h3>
            <p className='mb-4'>
              NTT
              DXパートナーは、特定個人情報等の取り扱いの全部又は一部を委託する他の事業者に対して、NTT
              DXパートナーが取り扱う特定個人情報等を提供することがあります。この場合、NTT
              DXパートナーは、特定個人情報等を適正に取り扱うと認めた事業者等を選定し、適切な監督を行います。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-3 text-lg font-semibold'>(4) 共同利用</h3>
            <p className='mb-4'>
              NTT
              DXパートナーは、お預かりしている特定個人情報等を、特定の者との間で共同利用することはいたしません。
            </p>
          </section>

          <section className='mb-8'>
            <h2 className='mb-4 text-xl font-semibold'>
              (5) 安全管理措置に関する基本的な考え方（セキュリティ・ポリシー）
            </h2>
            <p className='mb-4'>
              NTT
              DXパートナーは、特定個人情報等を取り扱うに当たり、特定個人情報等を安全に管理するため、以下のような措置を適切に実施するよう努めます。
            </p>

            <ul className='mb-4 list-none pl-6'>
              <li className='mb-2'>
                <strong>1. 技術的な保護措置</strong>
                <p className='mt-2'>
                  特定個人情報等へのアクセス管理、持ち出し手段の制限、外部からの不正アクセスの防止等に適切な措置を講じることにより、特定個人情報等への不正なアクセスや特定個人情報等の漏えい、滅失、き損の防止に努めます。
                </p>
              </li>
              <li className='mb-2'>
                <strong>2. 組織的な保護措置</strong>
                <ul className='mt-2 list-disc pl-6'>
                  <li>
                    特定個人情報等を取り扱う各部署において特定個人情報等保護に係る責任者及び事務取扱担当者※5を置き、責任及び権限を明確に定めます。
                  </li>
                  <li>
                    特定個人情報等を安全に管理するため、社内規程、マニュアル等を定め事務取扱担当者に遵守させるとともに、遵守状況についても定期的に適切に管理、監督します。
                  </li>
                  <li>
                    事務取扱担当者に対して定期的に適切な教育研修を実施することにより、特定個人情報等の重要性について十分に認識し特定個人情報等を適正に取り扱うよう、従業者一人ひとりの意識の向上に努めます。
                  </li>
                  <li>
                    特定個人情報等の取り扱いを外部に委託する場合には、守秘義務契約の締結等により委託先においても適正に取り扱われるよう監督します。
                  </li>
                </ul>
                <p className='mt-2'>
                  ※5事務取扱担当者 ：
                  特定個人情報等の事務に従事する者をいいます。以下においても同様とします。
                </p>
              </li>
              <li className='mb-2'>
                <strong>3. 物理的な保護措置</strong>
                <p className='mt-2'>
                  特定個人情報等を取り扱う建物やフロアの入退室管理、盗難等の防止、システムや文書の持ち出し・保管時における施錠等の諸対策を講じます。
                </p>
              </li>
              <li className='mb-2'>
                <strong>4. 外的環境の把握</strong>
                <p className='mt-2'>
                  特定個人情報等を外国に保存する、又はその取り扱いを外国にある第三者に委託する等、外国で取り扱う場合には、番号法及び個人情報保護法の規定に従い、各国の個人情報の保護に関する制度を把握して適切な措置を講じます。
                </p>
              </li>
            </ul>
          </section>

          <section className='mb-8'>
            <h2 className='mb-4 text-xl font-semibold'>(6) 開示・訂正等の手続</h2>
            <p className='mb-4'>
              NTT
              DXパートナーは、特定個人情報等の利用目的の通知又は特定個人情報等の開示（以下「開示等」といいます。）若しくは特定個人情報等の訂正、追加若しくは削除又は利用停止（以下「訂正等」といいます。）のお申出（以下「開示・訂正等のお申出」といいます。）について、以下のとおり手続を定めます。
            </p>

            <ul className='mb-4 list-none pl-6'>
              <li className='mb-2'>
                <strong>1. 開示・訂正等のお申出先</strong>
                <p className='mt-2'>
                  03-6803-4400
                  <br />
                  （午前9時～午後5時30分／土曜・日曜・休日･年末年始を除く）
                </p>
              </li>
              <li className='mb-2'>
                <strong>2. 開示・訂正等の手続</strong>
                <p className='mt-2'>
                  <strong>ア．開示等の手続</strong>
                </p>
                <ul className='mt-2 list-disc pl-6'>
                  <li>
                    NTT
                    DXパートナーは、開示等のお申出があったときは、電磁的記録の提供による方法、書面の交付による方法その他当社の定める方法のうち本人が請求した方法により回答します。ただし、本人が請求した方法により開示を行うことが困難であると当社が判断したときは、その旨及びその理由をお伝えし、書面の交付による開示を行います。いずれの場合においても、開示等のお申出は、NTT
                    DXパートナーがあらかじめ定めた様式に従った書面を提出することにより行っていただくものとします。
                  </li>
                  <li>
                    NTT
                    DXパートナーは、開示等のお申出があった場合においても、個人情報保護法及び番号法の規定に基づき、その一部又は全部について開示等をしないことがあります。この場合においては、NTT
                    DXパートナーは、開示等をしない旨及びその理由をお知らせします。なお、代理人に対しては、特定個人情報等を開示することにより人の生命、身体、財産その他の権利利益を害するおそれがある場合等は、対象となる個人情報の全部又は一部を開示しないことがあります。
                  </li>
                  <li>
                    開示等をご希望の方は前記[1]記載のお申出先にご連絡ください。手続の詳細についてご案内します。
                  </li>
                </ul>

                <p className='mt-4'>
                  <strong>イ．訂正等の手続</strong>
                </p>
                <ul className='mt-2 list-disc pl-6'>
                  <li>
                    NTT
                    DXパートナーは、訂正等のお申出があったときは、そのお申出内容について調査を行います。この場合において、訂正等のお申出はNTT
                    DXパートナーがあらかじめ定めた様式に従った書面を提出することにより行っていただくものとします。
                  </li>
                  <li>
                    NTT
                    DXパートナーは、調査の結果、特定個人情報等の内容が事実でないときその他当該特定個人情報等の取り扱いが適正でないと認めるときは、訂正等を行います。
                  </li>
                  <li>
                    訂正等をご希望の方は前記[1]記載のお申出先にご連絡ください。手続の詳細についてご案内します。
                  </li>
                </ul>
              </li>
              <li className='mb-2'>
                <strong>3. 本人確認等</strong>
                <p className='mt-2'>
                  開示・訂正等のお申出に当たっては、対象となる特定個人情報等に係る本人又はその代理人であることを確認できる書面が必要となります。必要となる書面の詳細については前記[1]記載のお申出先にお尋ねください。
                </p>
              </li>
              <li className='mb-2'>
                <strong>4. 開示等のお申出に係る手数料の額等</strong>
                <ul className='mt-2 list-disc pl-6'>
                  <li>
                    手数料 ： お申出ごとに基本料金400円(税抜)
                    及び、開示希望情報の項目、量等に応じた手数料が加算されます。
                  </li>
                  <li>送料 ： 簡易書留による郵送に係る実費</li>
                  <li>請求方法 ： ご請求の都度、請求書を送付します。</li>
                  <li>
                    その他手数料の額等の詳細については、前記[1]記載のお申出先にお尋ねください。
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section className='mb-8'>
            <h2 className='mb-4 text-xl font-semibold'>
              (7) 個人情報の取り扱いに関するご意見等の受付窓口
            </h2>
            <p className='mb-4'>
              NTT
              DXパートナーの特定個人情報等の取り扱いに関するご相談、ご要望等については、以下のお申出先で承ります。
            </p>
            <div className='rounded-md bg-gray-100 p-4 shadow-md'>
              <p className='text-lg font-medium'>03-6803-4400</p>
              <p className='mt-2 text-sm text-gray-600'>
                （午前9時～午後5時30分 ／ 土曜・日曜・休日･年末年始を除く）
              </p>
            </div>
          </section>
        </section>

        <section className='mb-8'>
          <h1 className='mb-4 text-xl font-semibold'>4. Googleアナリティクスの利用について</h1>
          <p className='mb-4'>
            本サイトでは、サイトの利用状況を把握するためにGoogleアナリティクスを利用しています。Googleアナリティクスは、クッキーを利用して本サイトの利用状況を収集します。サイト利用者は、「Googleアナリティクス
            オプトアウト
            アドオン」をインストールし、ブラウザのアドオン設定を変更することで、Googleによる情報の収集を停止することができます。詳細については、以下のサイトをご覧ください。
          </p>
          <div className='flex flex-col gap-2'>
            <Link
              to={'https://marketingplatform.google.com/about/analytics/terms/jp/'}
              className='text-primary-500 underline hover:text-primary-700'
            >
              Googleアナリティクス利用規約
            </Link>
            <Link
              to={'https://policies.google.com/privacy?hl=ja'}
              className='text-primary-500 underline hover:text-primary-700'
            >
              Googleのプライバシーポリシー
            </Link>
            <Link
              to={'https://tools.google.com/dlpage/gaoptout?hl=ja'}
              className='text-primary-500 underline hover:text-primary-700'
            >
              Googleアナリティクス オプトアウト アドオン
            </Link>
          </div>
        </section>

        <section className='mb-8'>
          <h1 className='mb-4 text-xl font-semibold'>5. 改定</h1>
          <p className='mb-4'>
            NTT
            DXパートナーは、このプライバシーポリシーの内容の全部又は一部を改定することがあります。改定した場合には、このホームページの掲載内容に反映すること等により公表します。
          </p>
        </section>
      </div>
    </main>
  );
};

export default PrivacyPolicyForm;
